export const ADD_TARGET_SOURCE = "/target_source/add";
export const ALL_TARGET_SOURCES = "/target_source/list";
export const DELETE_TARGET_SOURCE = "/target_source/delete";
export const UPDATE_TARGET_SOURCE = "/target_source/update";
export const TARGET_SOURCE_BY_ID = "/target_source/detail";
